import { useContext } from "@nuxtjs/composition-api";
import IS_EMAIL_EXISTS from "~/graphql/isEmailExists.graphql";
import IS_MOBILE_EXISTS from "~/graphql/isMobileExists.graphql";

export function useRegistrationExistenceChecks() {
  const { $query, $logger } = useContext();

  async function checkEmailExists(email) {
    if (!email) return false;
    try {
      const resp = await $query(IS_EMAIL_EXISTS, { email });
      return !!resp?.isEmailExists;
    } catch (e) {
      $logger.error("isEmailExists check failed", e);
      return false;
    }
  }

  async function checkMobileExists({ number, countryCodeId }) {
    if (!number || !countryCodeId) return false;
    try {
      const resp = await $query(IS_MOBILE_EXISTS, {
        mobile: number,
        phoneCountryCodeId: countryCodeId,
      });
      return !!resp?.isMobileExists;
    } catch (e) {
      $logger.error("isMobileExists check failed", e);
      return false;
    }
  }

  return { checkEmailExists, checkMobileExists };
}
